import * as React from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import CustomModal from "common/components/CustomModal/CustomModal";
import {
	ModalBody,
	ModalHeader,
	ModalPanel,
} from "common/components/CustomModal/Modal/ModalFrame";
import ModalHelper from "common/helpers/modalHelper";
import { Colors } from "styles/Colors";
import { formatUtc, parsePayload, renderText } from "./notificationText";

const useStyles = makeStyles((theme) => ({
	wrap: { maxWidth: 480 },
	notification: {
		display: "flex",
		gap: theme.spacing(2),
		padding: theme.spacing(2),
		borderRadius: 10,
		backgroundColor: Colors.panelDark,
		border: `1px solid ${Colors.panelLight}`,
	},
	icon: { width: 48, height: 48, borderRadius: 8, flexShrink: 0 },
	title: { fontWeight: 600, lineHeight: 1.3 },
	body: { color: Colors.primaryDark, whiteSpace: "pre-wrap" },
	url: { color: Colors.secondary, wordBreak: "break-all" },
	meta: {
		display: "flex",
		flexWrap: "wrap",
		gap: theme.spacing(3),
		marginTop: theme.spacing(3),
	},
	metaValue: { fontSize: 14 },
	raw: {
		margin: 0,
		padding: theme.spacing(1.5),
		borderRadius: 8,
		backgroundColor: Colors.panelDark,
		color: Colors.primaryDark,
		fontSize: 12,
		maxHeight: 180,
		overflow: "auto",
	},
}));

function Meta({ label, children }) {
	const classes = useStyles();
	return (
		<div>
			<Typography variant="caption">{label}</Typography>
			<div className={classes.metaValue}>{children}</div>
		</div>
	);
}

export default function NotificationPreviewModal({ row }) {
	const classes = useStyles();
	const payload = parsePayload(row);
	const rendered = renderText(payload);
	const title = rendered.title ?? row.title;
	const body = rendered.body ?? row.body;
	const url = payload?.url;

	return (
		<CustomModal>
			<ModalPanel>
				<ModalHeader onClose={() => ModalHelper.closeModal()}>
					Notification preview
				</ModalHeader>
				<ModalBody>
					<Box className={classes.wrap}>
						{title ? (
							<div className={classes.notification}>
								<img
									className={classes.icon}
									src="/favicon.png"
									alt=""
								/>
								<div>
									<div className={classes.title}>{title}</div>
									<div className={classes.body}>{body}</div>
									{url && (
										<Typography
											variant="caption"
											className={classes.url}
										>
											{url}
										</Typography>
									)}
								</div>
							</div>
						) : (
							<Typography variant="body2">
								This payload renders no notification.
							</Typography>
						)}

						<div className={classes.meta}>
							<Meta label="Sent (UTC)">{formatUtc(row.sentAt)}</Meta>
							<Meta label="Type">{row.type}</Meta>
							<Meta label="Audience">{row.audience}</Meta>
							{row.eventId != null && (
								<Meta label="Event">{row.eventId}</Meta>
							)}
							<Meta label="Delivered">
								{row.deliveredCount} / {row.attemptedCount}
							</Meta>
						</div>

						<Box mt={3} mb={1}>
							<Typography variant="caption">Payload</Typography>
						</Box>
						<pre className={classes.raw}>
							{payload
								? JSON.stringify(payload, null, 2)
								: row.payloadJson}
						</pre>

						<Box mt={2}>
							<Typography variant="caption">
								Times render in your timezone, each recipient saw
								their own.
							</Typography>
						</Box>
					</Box>
				</ModalBody>
			</ModalPanel>
		</CustomModal>
	);
}
